import { formatCurrency } from '@angular/common';

import { DetailScreen } from '../mapping-classes/detail-screen';
import { DetailPanel } from '../mapping-classes/detail-panel';
import { DetailLabel } from '../mapping-classes/detail-label';
import { ButtonData } from '../mapping-classes/button-data';

export class Consumptivefinance implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;
  productCode: string;

  constructor(response: any) {
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.productCode = `(${response.detailsViewObject.productCode})` || '';
      this.title = `${response.detailsViewObject.productName} ${this.productCode}`;
      this.actualityDateTime = response.detailsViewObject.actualityDate;
      this.addButtons(response);
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      if (response.detailsViewObject && response.detailsViewObject.restrictedData) {
        this.restrictedData = response.detailsViewObject.restrictedData;
      }
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setNameAndValues();
      this.addValues(response);
    }
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    this.panels.push(new DetailPanel('Productgebruik'));
  }

  setNameAndValues() {
    let product: DetailPanel = this.panels[0];
    this.fillProductFeatures(product);

    product = this.panels[1];
    this.fillProductAgreements(product);

    product = this.panels[2];
    this.fillProductUsage(product);
  }

  addValues(response: any) {
    const obj = response.detailsViewObject || [];
    let productDetailsPanel: DetailPanel = this.panels[0];
    this.addValuesToProductFeatures(productDetailsPanel, obj);

    productDetailsPanel = this.panels[1];
    this.addValuesToProductAgreements(productDetailsPanel, obj);

    productDetailsPanel = this.panels[2];
    this.addValuesToProductUsage(productDetailsPanel, obj);
  }

  addButtons(response) {
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductFeatures(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('contractNumber', new DetailLabel('Contractnummer'));
    productDetailsPanel.nameAndValues.set('productName', new DetailLabel('Product'));
    productDetailsPanel.nameAndValues.set('status', new DetailLabel('Status'));
  }

  private addValuesToProductFeatures(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('contractNumber').setValue(obj.contractNumber || '-');
    productDetailsPanel.nameAndValues.get('productName').setValue(obj.productName || '-');
    productDetailsPanel.nameAndValues.get('status').setValue(obj.status || '-');
  }

  private fillProductAgreements(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('creditAmount', new DetailLabel('Kredietbedrag'));
    productDetailsPanel.nameAndValues.set('rentPercentage', new DetailLabel('Rentepercentage'));
    productDetailsPanel.nameAndValues.set('objectCode', new DetailLabel('Object code'));
    productDetailsPanel.nameAndValues.set('activationDate', new DetailLabel( 'Verstrekkingsdatum'));
    productDetailsPanel.nameAndValues.set('lifeInsuranceCode', new DetailLabel('OLRV code'));
    productDetailsPanel.nameAndValues.set('objectDescription', new DetailLabel('Object omschrijving'));
    productDetailsPanel.nameAndValues.set('amountMonthlyTerm', new DetailLabel('Periodebedrag'));
  }

  private addValuesToProductAgreements(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('creditAmount')
      .setValue(formatCurrency(obj.creditAmount, 'nl', '€') || '-');
    productDetailsPanel.nameAndValues.get('rentPercentage').setValue(obj.rentPercentage || '-');
    productDetailsPanel.nameAndValues.get('objectCode').setValue(obj.objectCode || '-');
    productDetailsPanel.nameAndValues.get('activationDate').setValue(obj.activationDate || '-');
    productDetailsPanel.nameAndValues.get('lifeInsuranceCode').setValue(obj.lifeInsuranceCode || '-');
    productDetailsPanel.nameAndValues.get('objectDescription').setValue(obj.objectDescription || '-');
    productDetailsPanel.nameAndValues.get('amountMonthlyTerm')
      .setValue(formatCurrency(obj.amountMonthlyTerm, 'nl', '€') || '-');
  }

  private fillProductUsage(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('amountNetBalance', new DetailLabel('Netto restant schuld'));
    productDetailsPanel.nameAndValues.set('amountArrearsTerms', new DetailLabel('Achterstand termijnen'));
    productDetailsPanel.nameAndValues.set('reasonContractBlockedDesc', new DetailLabel('Blokkeer reden'));
    productDetailsPanel.nameAndValues.set('remainingDurationInMonths', new DetailLabel('Restant looptijd'));
    productDetailsPanel.nameAndValues.set('dateFinalPayment', new DetailLabel('Laatste betaaldatum'));
  }

  private addValuesToProductUsage(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('amountNetBalance')
      .setValue(formatCurrency(obj.amountNetBalance, 'nl', '€') || '-');
    productDetailsPanel.nameAndValues.get('amountArrearsTerms')
      .setValue(formatCurrency(obj.amountArrearsTerms, 'nl', '€') || '-');
    productDetailsPanel.nameAndValues.get('reasonContractBlockedDesc').setValue(obj.reasonContractBlockedDesc || '-');
    productDetailsPanel.nameAndValues.get('remainingDurationInMonths').setValue(obj.remainingDurationInMonths || '-');
    productDetailsPanel.nameAndValues.get('dateFinalPayment').setValue(obj.dateFinalPayment || '-');
  }

  private addSubHeaderToPanel(panel: DetailPanel, title) {
    panel.subPanels.push(new DetailPanel(title));
  }
}
